import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectSOinfo, selectSOlistReg, selectSONOinfolist } from '../../Selectors/Master/ItemSelectors';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';
import { fetchSOinfolist, fetchSOnoInfolist, fetchSORegister } from '../../../Store/PHPSlice/Sale/SaleOrder';
import FirmHeaderImg from '../../FieldsComponents/FirmHeaderImg';

const SOInfo = () => {
    const [formData, setFormData] = useState({
        dt: '',
        partyNm: '',
        adrs: '',
        contact: '',
        quotNo: '',
        itemNm: '',
        mulItem: [],
        gst: '',
        sono: '',
        orderno: '',
        schlNm: '',
        size: [],
        rate: [],
        qty: [],
        totQty: '',
        mclothNm: '',
        m1clothNm: '',
        m2clothNm: '',
        m3clothNm: '',
        mstk: '',
        m1stk: '',
        m2stk: '',
        m3stk: '',
        firmId: '',
        instruction:''
    });
    const { Id } = useParams();
    const dispatch = useDispatch();
    const soinfolist = useSelector(selectSONOinfolist);
    // console.log(soinfolist);
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef(); // Ref for the component to be printed
    useEffect(() => {
        dispatch(fetchSOnoInfolist(Id));
    }, [Id, dispatch]);
    useEffect(() => {

        if (soinfolist.data && soinfolist.data.length > 0) {
            const item = soinfolist.data[0];
            const mulitems = soinfolist.data.map(val => val.ID);
            setFormData(prev => ({
                ...prev,
                dt: item.ordt || '',
                quotNo: item.quotNo || '',
                sono: item.sono || '',
                orderno: item.orderno || '',
                partyNm: item.partyNm || '',
                schlNm: item.schoolNm || '',
                contact: item.contact || '',
                adrs: item.adrs || '',
                gst: item.gst || '',
                itemNm: item.itemNm || '',
                mclothNm: item.mclothNm || '',
                m1clothNm: item.m1clothNm || '',
                m2clothNm: item.m2clothNm || '',
                m3clothNm: item.m3clothNm || '',
                mulItem: mulitems,
                mstk: item?.mainClothStock,
                m1stk: item?.m1ClothStock,
                m2stk: item?.m2ClothStock,
                m3stk: item?.m3ClothStock,
                firmId: item?.firmId,
                instruction:item?.instruction 
            }));
        }
    }, [soinfolist]);

    const tableContainerStyle = {
        marginLeft: isDesktop ? '2%' : '100%',
        width: isDesktop ? '95%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };

    function totalCalculation(formData) {
        if (formData.rate.length > 0 && formData.qty.length > 0) {
            const rateqty = formData.rate.length > 0 ? formData.rate.map((val, index) => {
                return (parseInt(val) * parseInt(formData.qty[index]));
            }) : '0'
            var sum = rateqty.reduce((sum, qty) => sum + qty, 0);
        }

        return sum;
    }
    const total = totalCalculation(formData);

    // console.log('formData.mulItem.length', soinfolist, formData.mulItem);

    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1% 0%', width: '100%' }} ref={componentRef}>
                        {formData?.firmId !== '' && <FirmHeaderImg firmId={formData?.firmId} />}
                        <h3 className='centered-heading'>Sale Order Info</h3>
                        <div className="dashed-line"></div>

                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>

                            <tbody>

                                <tr>
                                    <td style={{ width: '200px' }}>Party Name</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='light-color'>{formData.partyNm}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Sale Order No.</td>
                                    <td>:</td>
                                    <td style={{ padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.sono}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: '200px' }}>Order No</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.orderno}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}></td>
                                    <td>:</td>
                                    <td style={{ padding: ' 0.2% 1.5%' }} className='dark-color'></td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Address</td>
                                    <td>:</td>
                                    <td style={{ width: '25vw', padding: ' 0.2% 1.5%' }} className='light-color'>{formData.adrs}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Date</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.dt}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Mobile No.</td>
                                    <td>:</td>
                                    <td style={{ width: '25vw', padding: ' 0 1.5%' }}>{formData.contact}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>GST No.</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.gst}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>School Name</td>
                                    <td>:</td>
                                    <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='light-color'>{formData.schlNm}</td>
                                     <td style={{ width: '200px', paddingLeft: '2%' }}>Instruction</td>
                                    <td>:</td>
                                    <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='light-color'>{formData.instruction == "" ? '-' : formData.instruction}</td> 
                                </tr>

                            </tbody>

                        </table>


                        {
                            formData.mulItem.length > 0 &&
                            formData.mulItem.map((itemNm, index) => {

                                const totalValues = soinfolist.infoData[itemNm].info_soId.reduce(
                                    (totals, val) => {
                                        totals.totalRate += parseFloat(val.rate || 0); // Sum of rates
                                        totals.totalQty += parseFloat(val.qty || 0);   // Sum of quantities
                                        totals.totalAmount += parseFloat(val.rate || 0) * parseFloat(val.qty || 0); // Sum of amount (rate * qty)
                                        return totals;
                                    },
                                    { totalRate: 0, totalQty: 0, totalAmount: 0 } // Initial totals
                                );

                                const selectItem = soinfolist?.data?.find((item => item.ID === itemNm));
                                const clothiss = selectItem?.cltsts;
                                {/* console.log(clothiss); */ }
                                const par_item = `${selectItem.barcode} - ${selectItem.itemNm}`;
                                const main_coth = selectItem?.mclothNm !== '0' ? selectItem?.mclothNm : '';
                                const m1_coth = selectItem?.m1clothNm !== '0' ? selectItem?.m1clothNm : '';
                                const m2_coth = selectItem?.m2clothNm !== '0' ? selectItem?.m2clothNm : '';
                                const m3_coth = selectItem?.m3clothNm !== '0' ? selectItem?.m3clothNm : '';

                                const stk = selectItem?.mainClothStock !== '0' ? selectItem?.mainClothStock : '0';
                                const stk1 = selectItem?.m1ClothStock !== '0' ? selectItem?.m1ClothStock : '0';
                                const stk2 = selectItem?.m2ClothStock !== '0' ? selectItem?.m2ClothStock : '0';
                                const stk3 = selectItem?.m3ClothStock !== '0' ? selectItem?.m3ClothStock : '0';
                                const pricelist_cloth = selectItem?.pricelist_cloth;
                                const pricelist_type = selectItem?.pricelist_type;
                                const extra_rate = selectItem?.extra_rate;
                                const quotation_no = soinfolist?.infoData[itemNm]?.data?.quotNo || ' ';
                                const entryType = soinfolist?.infoData[itemNm]?.data?.entryType;

                                const cloth_req_mtr = soinfolist?.infoData[itemNm]?.data?.cloth_required_mtr;
                                const mreq = cloth_req_mtr?.main_req_mtr;
                                const m1req = cloth_req_mtr?.m1_req_mtr;
                                const m2req = cloth_req_mtr?.m2_req_mtr;
                                const m3req = cloth_req_mtr?.m3_req_mtr;
                                return (
                                    soinfolist.infoData[itemNm].info_soId.length > 0 && (

                                        <div>
                                            {/* <table style={{ margin: '1% 5%', fontSize: '14px' }}>
                                                <tr>
                                                    <td style={{ width: '200px' }}>Price List Cloth & Type</td>
                                                    <td style={{ width: '25vw', padding: ' 0.2% 1.5%' }} className='light-color'>{`${pricelist_cloth} (${pricelist_type})`}</td>
                                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Extra Rate</td>
                                                    <td style={{ width: '30vw', padding: ' 0.2% 1.5%' }} className='dark-color'>{extra_rate}</td>
                                                </tr>

                                            </table> */}
                                            <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle, margin: '1% 5%', fontSize: '14px', width: '90%', display: 'flex' }} key={index}>
                                                {entryType !== "Direct" &&
                                                    <Table>
                                                        <TableHead>
                                                            <TableRow className="tbl-row">
                                                                <TableCell sx={{ p: 0.4, border: "1px solid #000", fontSize: "15px" }} align="center">Quotation No.</TableCell>

                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            <TableCell sx={{ p: 0.4, border: "1px solid #000" }} align="center">
                                                                {quotation_no}
                                                            </TableCell>
                                                        </TableBody>
                                                    </Table>}
                                                <Table>
                                                    <TableHead>
                                                        <TableRow className="tbl-row">
                                                            <TableCell sx={{ p: 0.4, border: "1px solid #000", fontSize: "15px" }} align="center">Particulars</TableCell>

                                                        </TableRow>
                                                    </TableHead>

                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell sx={{ p: 0.4, border: "1px solid #000", fontSize: "15px" }} align="center">
                                                                {par_item} <br />
                                                                {/* {`cloth - ${main_coth}`} <br />
                                                            {`cloth1 - ${m1_coth}`} <br />
                                                            {`cloth2 - ${m2_coth}`} <br />
                                                            {`cloth3 - ${m3_coth}`} */}

                                                                {[
                                                                    { label: "cloth", value: main_coth, stk: stk, reqmtr: mreq },
                                                                    { label: "cloth1", value: m1_coth, stk: stk1, reqmtr: m1req },
                                                                    { label: "cloth2", value: m2_coth, stk: stk2, reqmtr: m2req },
                                                                    { label: "cloth3", value: m3_coth, stk: stk3, reqmtr: m3req },
                                                                ]
                                                                    .filter(c => c.value && c.value !== "0") // remove empty, null, or '0'
                                                                    .map((c, i) => (
                                                                        <div key={i} className="no-print">{`${c.label} - ${c.value}`}
                                                                            {c.reqmtr > 0 &&
                                                                                <span><br />{`\n(Req Mtr : ${c.reqmtr})`}</span>
                                                                            }
                                                                            {clothiss === '0' ? <span style={{
                                                                                color: (c.reqmtr <= c.stk) || c.stk > 0 ? "green" : "red",
                                                                                fontWeight: "bold"
                                                                            }}>{`\n(Stock : ${c.stk})`}</span> :
                                                                                <span style={{ color: 'green', fontWeight: "bold" }}><br />{`\n (Cloth Issue Done...)`}</span>
                                                                            }

                                                                        </div>
                                                                    ))}
                                                            </TableCell>

                                                        </TableRow>
                                                    </TableBody>
                                                </Table>


                                                <Table>
                                                    <TableHead>
                                                        <TableRow className="tbl-row">
                                                            <TableCell sx={{ p: 0.4, border: "1px solid #000", fontSize: "15px" }} align="center">Size</TableCell>
                                                            {soinfolist?.infoData[itemNm].info_soId.map((val, valIndex) => (
                                                                <TableCell key={valIndex} sx={{ p: 0.4, border: "1px solid #000" }} align="center">
                                                                    {val.size}
                                                                </TableCell>
                                                            ))}

                                                        </TableRow>
                                                    </TableHead>

                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell sx={{ p: 0.4, border: "1px solid #000", fontSize: "15px" }} align="center">Rate</TableCell>
                                                            {soinfolist?.infoData[itemNm].info_soId.map((val, valIndex) => (
                                                                <TableCell key={valIndex} sx={{ p: 0.4, border: "1px solid #000" }} align="center">
                                                                    {val.rate}
                                                                </TableCell>
                                                            ))}

                                                        </TableRow>
                                                        <TableRow>

                                                            <TableCell sx={{ p: 0.4, border: "1px solid #000", fontSize: "15px" }} align="center">Qty</TableCell>
                                                            {soinfolist?.infoData[itemNm].info_soId.map((val, valIndex) => (
                                                                <TableCell key={valIndex} sx={{ p: 0.4, border: "1px solid #000" }} align="center">
                                                                    {val.qty}
                                                                </TableCell>
                                                            ))}

                                                        </TableRow>
                                                    </TableBody>
                                                </Table>


                                                <Table>
                                                    <TableHead>
                                                        <TableRow className="tbl-row">

                                                            <TableCell sx={{ p: 0.4, border: "1px solid #000", fontSize: "15px" }} align="center">Total Qty</TableCell>
                                                            <TableCell sx={{ p: 0.4, border: "1px solid #000", fontSize: "15px" }} align="center">Total Amount</TableCell>
                                                        </TableRow>
                                                    </TableHead>

                                                    <TableBody>
                                                        <TableRow>

                                                            <TableCell sx={{ p: 0.4, border: "1px solid #000", fontSize: "15px" }} align="center">
                                                                {totalValues.totalQty}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 0.4, border: "1px solid #000", fontSize: "15px" }} align="center">
                                                                {totalValues.totalAmount.toFixed(2)}
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </div>
                                    )
                                );
                            })
                        }
                        {/* <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                            <Table>
                                <TableHead>
                                    <TableRow className='tbl-row'>
                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>ItemName</TableCell>
                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>Size</TableCell>
                                        {formData.size.length > 0 ? formData.size.map((item, index) => (
                                            <TableCell key={index} sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{item}</TableCell>
                                        )) : ''}
                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>Qty</TableCell>
                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>Amount</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>{formData.itemNm} <br />
                                            {formData.mclothNm !== '0' ? formData.mclothNm : ''} <br /> {formData.m1clothNm !== '0' ? formData.m1clothNm : ''}<br />
                                            {formData.m2clothNm !== '0' ? formData.m2clothNm : ''} <br /> {formData.m3clothNm !== '0' ? formData.m3clothNm : ''}</TableCell>
                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>Rate(&#8377;)</TableCell>
                                        {formData.rate.length > 0 ? formData.rate.map((item, index) => (
                                            <TableCell key={index} sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{item}</TableCell>
                                        )) : ''}
                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'> </TableCell>
                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'> </TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'> </TableCell>
                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'> </TableCell>
                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>Qty</TableCell>
                                        {formData.qty.length > 0 ? formData.qty.map((item, index) => (
                                            <TableCell key={index} sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{item}</TableCell>
                                        )) : ''}
                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>{formData.totQty}</TableCell>
                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>{total}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer> */}



                    </div>
                    <div style={{ margin: '2% 5%', paddingBottom: '2%' }}>
                        <ReactToPrint
                            trigger={() => <Button variant="contained" color="primary">Print</Button>}
                            content={() => componentRef.current}
                        />
                    </div>
                </Paper>
            </Grid>
        </>
    );
};

export default SOInfo;
